import { useHistory } from 'react-router-dom';

import { useLocalize } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';

import SettingsCollection, { ArchiveRestoreMutationTuple } from '../generic/SettingsCollection';

export default function TalentReviewsListContainer() {
	const history = useHistory();
	const { localize } = useLocalize();

	return (
		<SettingsCollection
			query={graphql.useTalentReviewTemplatesQuery}
			lazyQuery={graphql.useTalentReviewTemplatesLazyQuery}
			field="talentReviewTemplates"
			translationKey="settings.talentReviews"
			title={(title: graphql.TalentReviewTemplate) => localize(title.title).text}
			link={(title) => `/settings/talent-reviews/${title.id}`}
			variables={{}}
			archive={
				graphql.useArchiveTalentReviewTemplateMutation() as unknown as ArchiveRestoreMutationTuple
			}
			restore={
				graphql.useRestoreTalentReviewTemplateMutation() as unknown as ArchiveRestoreMutationTuple
			}
			onAdd={() => history.push('/settings/talent-reviews/new')}
		/>
	);
}
